<template>
  <base-invite>
    <template v-slot:invite-header>
      <h3>{{$t('organizations.users_section.modals.share_link.title')}}</h3>
    </template>
    <template v-slot:invite-body>
      <h4>{{ $t('organizations.users_section.modals.share_link.title_text') }}</h4>
      <div id="share-link">
        <div class="link elsa-input">
          <el-input
            :value="getShareLink"
            readonly
          >
          </el-input>
        </div>
        <chip icon="" class="elsa-icon-chain"
          v-clipboard="getShareLink"
          v-clipboard:success="clipboardSuccessHandler"
        >
          {{$t('organizations.users_section.modals.share_link.copy_link')}}
        </chip>
      </div>
    </template>
    <template v-slot:invite-footer>
      <primary-button
        @click.native="handleInviteClick">
        {{$t('organizations.users_section.modals.share_link.got_it')}}
      </primary-button>
      <tertiary-button
        @click.native="backToUsers"
      >
        {{$t('organizations.users_section.modals.share_link.cancel')}}
      </tertiary-button>
    </template>
  </base-invite>
</template>

<script>
  import BaseInvite from './BaseInvite'
  import Chip from '@/components/common/Chip'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  export default {
    components: {
      BaseInvite,
      Chip,
      PrimaryButton,
      TertiaryButton,
    },
    methods: {
      handleInviteClick(){
        return this.backToUsers();
      },
      backToUsers() {
        this.$emit('toggle-organization-nav', true)
        this.$emit('invite-users', 'users')
      },
      clipboardSuccessHandler() {
        return this.$message({
          message: this.$t('organizations.users_section.modals.share_link.link_copied'),
          center: true,
          customClass: 'elsa-message',
          offset: 115,
          iconClass: '',
        })
      }
    },
    computed: {
      getShareLink (){
        return "www.linktoacessorganization/imaginarycloud.com"
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../scss/_colors.scss';

  #share-link {
    display: flex;
    flex-direction: row;

    .link {
      flex: 1;
      padding: 0 8px 0 0;

     .el-input::v-deep {
        .el-input__inner {
          &:hover, &:active, &:focus {
            border: 1px solid $light-blue;
          }
        }
      }
    }


    ::v-deep .elsa-chip {
      margin-right: 130px;
    }
  }
</style>
